import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'material-ui';

import styles from './styles.scss';

export default class VendorListFilter extends React.Component {
  static propTypes = {
    numVendors: PropTypes.number,
    numFiltered: PropTypes.number,
    updateFilter: PropTypes.func.isRequired,
    filter: PropTypes.string,
  }

  static defaultProps = {
    numVendors: 0,
    numFiltered: 0,
    filter: '',
  }

  render() {
    const { numVendors, numFiltered, updateFilter, filter } = this.props;

    return (<div className={styles.listFilter}>
      <div className={styles.tripListFilters}>
        <div className={styles.filter}>
          <TextField
            floatingLabelText='Filter vendors by name'
            onChange={updateFilter}
            value={filter}
          />
        </div>
      </div>
      <div className={styles.infoLine}>
        {numFiltered} (of {numVendors}) vendors displayed
      </div>
    </div>);
  }
}



// WEBPACK FOOTER //
// /src/components/Vendors/VendorListFilters.js